import { useTranslation } from "react-i18next";
import useApiCallService from "../../Common/Helpers/ApiCall";
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";
import { CustomButton } from "../../Common/Components/Button/CustomButton";
import {ADMIN_PATHS, ORGANIZATION_PATHS} from "../../config";
import {useNavigate} from "react-router-dom";
import { Col, Row } from "reactstrap";
import { InfoPageMessage } from "../../Common/Components/Button/InfoPageMessage";
import SortableList from "../../Common/Components/Lists/SortableList";
import ResponseEconomicReportModel from "../Models/ResponseEconomicReportModel";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { useEffect } from "react";

const AdminEconomicReport = () => {
    const defaultStartDate = new Date();
    defaultStartDate.setHours(0);
    defaultStartDate.setMinutes(1);
    defaultStartDate.setSeconds(0);
    defaultStartDate.setMilliseconds(0);
    const defaultEndDate = new Date();
    defaultEndDate.setHours(23);
    defaultEndDate.setMinutes(59);
    defaultEndDate.setSeconds(59);
    defaultEndDate.setMilliseconds(0);
    const { t } = useTranslation();
    const { ApiCall } = useApiCallService();
    const navigate = useNavigate();
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('economicReport.economicReport'));
        setPageTitleKey('economicReport.economicReport');
        setOnBack(null);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);
  
    const handleDownloadApiResponse  =  (response, name) => {
        let file;
        if (response instanceof Blob) {
          file = response;
          
        } else {
          file = new Blob([response]);
        }
        let fileName = name;

        if (!name || name.trim() === "") {
            fileName = "file.pdf";
        } else {
            fileName = name;
        }

        const urlToFile = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = urlToFile;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        /*setTimeout(() => {
          CustomReload();
        }, 2000);*/
    }

    const DownloadFile = async (id, fileName) => {
        let url = `/file?id=${id}`        
        const apiCallOptions = {
            method: "get",
            url: url,
            dataTypes: 'blob',
            responseType: 'blob'
        };
        try {
            await ApiCall(apiCallOptions, (response) => handleDownloadApiResponse(response, fileName));

        } catch (error) {
            console.log(error);
        }
    };
    /*const renderActionColumn = (item) => {
        return (
            <>
                <CustomButton icon="bx bx-down-arrow-alt pb-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4}  buttonColor="#cde0da"  tooltipText='Nedladdningar' customClasses="rounded" buttonBorder={false} customClassesTooltip="tooltip-custom-button-table"
                              id={item.id}
                              onClick={() => {
                              DownloadFile(item.fileId, item.fileName);
                            }}
                />
            </>
        );
    }*/
        const renderActionColumn = (item) => {
            if (item.id !== null && item.id !== undefined) {
                return (
                    <CustomButton
                        icon="bx bx-show pb-1"
                        iconColor="#157553"
                        hoverIconColor="white"
                        hoverButtonColor="#A3C2B8"
                        iconSize={4}
                        buttonColor="#cde0da"
                        tooltipText={t('button.info')}
                        customClasses="rounded"
                        buttonBorder={false}
                        id={item.id}
                        onClick={() => {
                            const idToUse = (item.accountRowId && item.model?.includes('Förrättning')) 
                                ? item.accountRowId 
                                : item.id;
                            const newUrl = `${ADMIN_PATHS.ADMIN_ECONOMIC_REPORT_INFO}?id=${idToUse}`;
                            navigate(newUrl, { state: { item, modelId: item.modelId } });
                        }}
                    />
                );
            }
        };

    const columns = ["createdAt",'reimbursementDate','costPlace','costBearerName','orgType','orgName','model', 'relatedReimbursementModel','details', 'relatedReimbursementExtraInfo','createdByName','amount'];

    const listOptions = {
        "model": ResponseEconomicReportModel,
        'columns': columns,
        "actions": {
            "actionColumn" : renderActionColumn,
        },
        "exportIsAvailable": true,
        "filterTestIsAvailable": true,
        "economicReportFilter": true,
        "urlGetListItemsToExport": "/export-data/admin/search-economic-report",
        "nameFile": t('sidebar.economicReport'),
        "modelType" : "EconomicReport",
        "ignoreFields" : [...columns],
        "urlGetSearch" : "/export-data/admin/search-economic-report",
        "viewName": "AdminEconomicReport",
    };
      return (
        <>        
          <Col lg="12" className='card card-backend p-4 mb-5'>
                <Row>
                    <Col xs='auto'>
                        <h2 className='rokkitt-font'>{t('economicReport.economicReport')}</h2>
                    </Col>
                    <InfoPageMessage message={t('infoBox.economicReport')}/>
                </Row>
                <SortableList
                    listOptions={{
                        ...listOptions,
                        filtersOpen: true
                    }}
                />
            </Col>
        </>
    );
};

export default AdminEconomicReport;